import React, {useState, useEffect, useRef, useCallback, JSX } from 'react'
import Chart, { Grid as GridChart, CommonSeriesSettings, ArgumentAxis, Series, Legend, ValueAxis, ZoomAndPan, ScrollBar, Tooltip, TickInterval, Aggregation, Point, Title, AggregationInterval, Label, Height, Crosshair, Font, MinorTickInterval, Tick, MinorTick, Strip, CommonAxisSettings } from 'devextreme-react/chart';
import CardHeader from "components/Card/CardHeader.js";
import RangeSelector, {
    Size, Chart as ChartOptions, Margin, Scale, Behavior, RangeSelectorTypes,
} from 'devextreme-react/range-selector';
import moment from 'moment'
import { Grid, Tooltip as TooltipMUI } from '@mui/material';
import DateRange from '../../components/Dates/DateRange';
import { TextField, Chip, Button, Select, MenuItem, Checkbox } from "@mui/material"
import { CallGetAPI, CallPostAPI, CreateUrl } from '../../Utils/ApiHelper';
import { VisualRange } from 'devextreme-react/common/charts';
import ClipLoader from "react-spinners/ClipLoader";
import { Start } from '@mui/icons-material';
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';
import { useTheme } from '@mui/material/styles'
import { GraphTemplate, graphTemplateModel, GraphSettings, deepCopyAshridgeDefault } from '../../models/GraphTemplateModel'
import { NotificationManager } from 'react-notifications';
import { FormattedMessage, useIntl, IntlShape } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import { UserSettings } from '../../models/APIUserSettingsModel'
import Modal from 'react-bootstrap/Modal'
import CustomNumberInputChanger from '../CustomInput/CustomNumberInputChanger';
import { MuiColorInput } from 'mui-color-input';
import Loader from '../../Utils/Loader/NewLoader2025'
interface Props {
    serial: number | null
    siteId: number | null
    loggerData: Array<APISiteLoggerDetail> | null
    startDateProps: Date
    endDateProps: Date
    showDateLink : boolean
}

interface MNFData {
    calcTimeUTC: Date
    channel: string
    fkCompanyId: number | null
    fkLCLoggerId: number | null
    fkLoggerId: number | null
    id: number
    minValue: number
    minValueTimeStamp: Date
    minValueTimeStampDisplay: Date
    serial: number
    siteId: number | null
    loggerBreakdown: string | null
}

interface UserTemplate {
    createdDate: Date
    fkCompanyId: number
    graphSettings: GraphSettings
    serial: number | null
    siteId: number | null
    userId: number | null
}
interface UserTemplateJSON {
    createdDate: Date
    fkCompanyId: number
    graphSettings: string
    serial: number | null
    siteId: number | null
    userId: number | null
}


interface MultiLoggerColumnData {
    day: Date
    [key: string]: number | Date | null | undefined
    average: number | null
    dailyTotal: number
    timeOfReading: Date
}
interface loggerInfo {
    serial: number
    color: string
}

interface Breakdown {
    loggerserial: string
    flow: string
}

interface APISiteLoggerDetail extends APILoggerDetail {
    IsSiteOutput: boolean
}
interface AvgStyling {
    color: string
    width: number
    showPoints: boolean
    size: number
}
  
 


const MinimumNightFlow: React.FC<Props> = ({ serial, siteId, loggerData, startDateProps, endDateProps, showDateLink }) => {
    const language = sessionStorage.getItem("language")
    if (language) {
        locale(language);
    }
    
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);



    const intl = useIntl()
    const theme = useTheme()
    const chartRef = useRef(null)
    const [graphData, setGraphData] = useState<Array<MultiLoggerColumnData>>([])
    const [startDate, setStartDate] = useState<Date>(moment().subtract(3, 'months').set({ hour: 0, minute: 0, second: 0 }).toDate())
    const [endDate, setEndDate] = useState<Date>(moment().set({hour: 0, minute: 0, second: 0}).toDate())
    const [visualRange, setVisualRange] = useState<VisualRange>({ startValue: startDate, endValue: endDate })
    const [loggers, setLoggers] = useState<Array<loggerInfo>>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [dateChange, setDateChange] = useState<boolean>(false)
    const [shouldReloadData, setShouldReloadData] = useState<boolean>(false)
    const [linkDates, setLinkDates] = useState<boolean>(false)
    const [customColours, setCustomColours] = useState<boolean>(false)
    const [reloadDataCount, setReloadDataCount] = useState<number>(0)
    const [useCustomColors, setUseCustomColors] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [averageStyling, setAverageStyling] = useState<AvgStyling>({ color: '#FF69B4', width: 2, showPoints: true, size: 5})
    const [tempAverageStyling, setTempAverageStyling] = useState<AvgStyling>(averageStyling)
    const [showModal, setShowModal] = useState<boolean>(false)
    const [outputLoggers, setOutputLoggers] = useState<Array<number>>([])
    useEffect(() => {
        reloadData()

    }, [])

    useEffect(() => {
        if (showDateLink === false) {
            setLinkDates(false)
        } else if (showDateLink === true) {
            CallGetAPI(CreateUrl(`/api/aquaguard/usersettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF`), {})
                .then((data: UserSettings[]) => {
                    for (const userSetting of data) {
                        if (userSetting.settingsKey === 'Link Dates' && userSetting.settingsValue === 'true') {
                            setLinkDates(true)
                            setStartDate(startDateProps)
                            setEndDate(endDateProps)
                            setShouldReloadData(true)
                        }
                    }
                })
        }

    }, [showDateLink])


    useEffect(() => {
        if (reloadDataCount !== 0 && linkDates) {
            onDateChange(startDateProps, endDateProps, false, true)
        }
        setReloadDataCount(prev => prev +1)
    }, [startDateProps, endDateProps])


    useEffect(() => {
        CallGetAPI(CreateUrl(`/api/aquaguard/usersettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF`), {})
            .then((data: UserSettings[]) => {
                for (const userSetting of data) {
                    if (userSetting.settingsKey === 'Custom Average') {
                        const avgSett: AvgStyling = JSON.parse(userSetting.settingsValue)
                        avgSett.color = `#${avgSett.color}`
                        setAverageStyling(avgSett)
                    }
                }
            })
    }, [graphData])

    const professionalColors = [
        "#2C5F9B", // Deep blue
        "#4CAF50", // Forest green
        "#6A4C93", // Muted purple
        "#F4B740", // Golden yellow
        "#00ACC1", // Teal blue
        "#5D4037", // Dark brown
        "#3F51B5", // Indigo
        "#607D8B", // Blue gray
        "#009688", // Teal green
        "#7CB342", // Light green
        "#1565C0", // Darker blue
        "#8E24AA", // Rich purple
        "#00897B", // Deep teal
        "#546E7A", // Slate
        "#43A047"  // Emerald green
    ];

    
 
    const reloadData = (): void => {

        setLoading(true)
        let customColor = false
        if (serial) {
            CallGetAPI(CreateUrl(`/api/aquaguard/getmnf?serial=${serial}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`), {})
                .then(async (data: Array<MNFData>) => {
                    const sortedData: Array<MultiLoggerColumnData> = []

                    if (data.length > 0) {
                        customColor = await checkForCustomColorsAPI()
                        for (let i = 0; i < data.length; i++) {
                            data[i].minValueTimeStampDisplay = moment(data[i].minValueTimeStamp).startOf('day').toDate()
                            let average = 0
                            if (i > 5) {
                                for (let j = 0; j < 7; j++) {
                                    average += data[i - j].minValue
                                }
                                average /= 7
                            }
                            sortedData.push({
                                day: data[i].minValueTimeStampDisplay,
                                timeOfReading: data[i].minValueTimeStamp,
                                [`${data[i].serial}`]: parseFloat(data[i].minValue.toFixed(3)),
                                average: i > 5 ? parseFloat(average.toFixed(3)) : null,
                                dailyTotal: data[i].minValue
                            })
                        }
                    }

                    const loggersData =[]
                    if (!loggers[0]?.color || !useCustomColors) {
                        loggersData.push({
                            serial: serial, color: professionalColors[0]
                        })
                       
                    } else {
                        loggersData.push({ serial: serial, color: professionalColors[0] === loggers[0].color ? professionalColors[0] : loggers[0].color })
                    }
                    setLoggers(loggersData)
                    setGraphData(sortedData)
                    setLoading(false)

                    if (customColor) {
                        setUseCustomColors(true)
                        handleCustomColorLoad(loggersData)
                    }
                })
                .catch(err => console.log(err))
        } else if (siteId) {
            CallGetAPI(CreateUrl(`/api/aquaguard/getmnf?siteId=${siteId}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`), {})
                .then(async (data: Array<MNFData>) => {
                    const loggersInSite: Array<loggerInfo> = []
                    const outputLoggersTemp: Array<number> = []
                    if (loggerData) {
                        customColor = await checkForCustomColorsAPI()
                        loggerData.forEach((logger: number) => {
                            if (logger.isSiteOutput) {
                                outputLoggersTemp.push(logger.serial)
                            }
                            if (!loggersInSite.map(i => i.serial).includes(logger.serial)) {
                                loggersInSite.push({ serial: logger.serial, color: professionalColors[loggersInSite.length] })
                            }

                        })
                    }
                    
                    const sortedData: Array<MultiLoggerColumnData> = []
                    
                    for (let i = 0; i < data.length; i++) {
                        if (!data[i].serial) {
                            const dailyInfo: MultiLoggerColumnData = {}
                            let average = 0
                            dailyInfo.day = moment(data[i].minValueTimeStamp).startOf('day').toDate()
                            dailyInfo.timeOfReading = moment(data[i].minValueTimeStamp).toDate()
                            if (data[i].loggerBreakdown) {
                                const breakDown = JSON.parse(data[i].loggerBreakdown)

                                breakDown.forEach((log: Breakdown) => {
                                    if (outputLoggersTemp.includes(parseInt(log.loggerserial))) {
                                        dailyInfo[`${log.loggerserial}`] = Number(-parseFloat(log.flow).toFixed(3))
                                    } else {
                                        dailyInfo[`${log.loggerserial}`] = Number(parseFloat(log.flow).toFixed(3))
                                    }
                                })
                            }

                            if (i > 5) {
                                for (let j = 0; j < 7; j++) {
                                    let outputFlow = 0
                                    const breakDown = JSON.parse(data[i - j].loggerBreakdown)
                                    breakDown.forEach((log: Breakdown) => {
                                        if (outputLoggersTemp.includes(parseInt(log.loggerserial))) {
                                            outputFlow += parseFloat(log.flow)
                                        }
                                    })
                                    average += data[i - j].minValue - (outputFlow * 2)
                                }
                                average /= 7
                                dailyInfo.average = parseFloat(average.toFixed(3))
                            } else {
                                dailyInfo.average = null
                            }


                            sortedData.push(dailyInfo)
                        }
                    }

                    setOutputLoggers(outputLoggersTemp)
                    setLoggers(loggersInSite)
                    setGraphData(sortedData)
                    setLoading(false)
                    if (customColor) {
                        setUseCustomColors(true)
                        handleCustomColorLoad(loggersInSite)
                    }
                })
                .catch(err => console.log(err))
        }
        
    }

    const checkForCustomColorsAPI = async (): Promise<boolean> => {
        CallGetAPI(CreateUrl(`/api/aquaguard/usersettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF`), {})
        try {
            const data: UserSettings[] = await CallGetAPI(CreateUrl(`/api/aquaguard/usersettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF`), {})
            if (data.length > 0) {

                for (const userSetting of data) {
                    if (userSetting.settingsKey === 'Custom Colours' && userSetting.settingsValue === 'true') {
                        setUseCustomColors(true)

                        return true
                    }
                }
            }
            return false
        
        } catch (err) {
            console.error(err)
            return false
        }
    }

    //NOTIFICATIONS
    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Template' }), 'Success')

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }));
    };


    const renderToolTip = (point, intl:IntlShape): React.ReactNode => {
        return (
            <div>
                <p>{`${intl.formatMessage({ id: 'Bar/Line' })}: ${point.seriesName}` }</p>
                <p>{`${intl.formatMessage({ id: 'Value' })}: ${point.originalValue} l/s`}</p>
                <p>{`${intl.formatMessage({ id: 'Time of minimum flow' })}: ${moment(point.point.data.timeOfReading).format("DD-MM-yyyy hh:mm:ss A")}`}</p>
            </div>
        )
    }

  
    const onDateChange = (startDateChange: moment, endDateChange: moment, rainfall, recent):void => {

        let finalDate = moment(endDateChange).toDate() >= moment().toDate() ? moment(endDateChange).set({hour: 0, minute: 0, second: 0}).toDate() : moment(endDateChange).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).toDate()
        if (finalDate > moment().toDate()) {
            finalDate = moment().set({hour: 0, minute: 0, second: 0}).toDate()
        }
        const beginDate = moment(startDateChange).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate()
        setStartDate(beginDate)
        setEndDate(finalDate)
        if (recent) {
            setShouldReloadData(true)
        } else {
            setDateChange(true)
        }
    }

    const handleRedraw = (): void => {

        setDateChange(false)
        reloadData()
        setVisualRange({startValue: startDate, endValue: endDate})
    }

    useEffect(() => {
        if (shouldReloadData) {
            handleRedraw()
            setShouldReloadData(false)
        }
    }, [startDate, endDate, shouldReloadData])

    

    const renderLoggerSeries = (logger:loggerInfo): Array<React.ReactNode> => {
 
        const loggerSeries = []
        loggerSeries.push(<Series
            valueField={logger.serial.toString()}
            color={logger.color}
            name={logger.serial}
            type="stackedbar"
        />)
       
        return loggerSeries
    }

    const renderCheckBox = (item:any): any => {
        const clicked = !item.series.isVisible()
        return (
            <svg>
                <rect x="0" y="0" width="18" height="18" fill="none" stroke={item.marker.fill} strokeWidth="1"></rect>
                {!clicked && <polyline points="3.5,10 8,14 14.5,4" fill="none" stroke={item.marker.fill} strokeLinecap="round" strokeWidth="2"></polyline>}
            </svg>
        );




    }

    const legendClickHandler = (e: any): void => {

        const series = e.target;
        if(series.isVisible()) {
        series.hide();
    } else {
        series.show();
        }

    }


    const customizeLegendText = (item, intl: IntlShape): string => {
        if (outputLoggers.includes(item.seriesName)) {
            return `<div style="font-size: 16px; color: black"}}>${item.seriesName}<br />${intl.formatMessage({ id: 'Output' })}</div>`
        } else {
            return `<div style="font-size: 16px; color: black"}}>${item.seriesName}</div>`
        }
        
    }

    const handleLinkDatesChecked = (): void => {
        CallPostAPI(CreateUrl(`/api/aquaguard/userSettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF&key=Link%20Dates&value=${!linkDates}`), {})
            .catch(err => {
                console.error(err)
                createErrorNotification()
            })
        if (linkDates) {
            setStartDate(moment().subtract(3, 'months').set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }).toDate())
            setEndDate(moment().toDate())
        } else {
            setStartDate(startDateProps)
            setEndDate(endDateProps)
        }
        setLinkDates(!linkDates)
        setShouldReloadData(true)
        
    }

    const handleCustomColorClick = () => {
        CallPostAPI(CreateUrl(`/api/aquaguard/userSettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF&key=Custom%20Colours&value=${!useCustomColors}`), {})
            .catch(err => {
                console.error(err)
                createErrorNotification()
            })
        if (useCustomColors) {
            setUseCustomColors(false)

            const loggersData = loggers
            loggersData.forEach((logger, idx) => {
                logger.color = professionalColors[idx]
            })
            setLoggers(loggersData)

        } else {
            setUseCustomColors(true)
            handleCustomColorLoad(undefined)
        }
    }

    const handleCustomColorLoad = (loggersDataProps: Array<APISiteLoggerDetail> | null | undefined): void => {
             CallGetAPI(CreateUrl(`/api/aquaguard/graphTemplate?CompanyId=${sessionStorage.getItem('companyId')}`), {})
            .then(data => {

                let userId
                if (sessionStorage.getItem('userId')) {
                    userId = sessionStorage.getItem('userId')
                }
                const extractedData = data.map((item: UserTemplateJSON) => {
                    item.graphSettings = JSON.parse(item.graphSettings)

                    return item
                })
                let userTemplate: UserTemplate[] | [] = []
                if (serial && userId) {
                    userTemplate = extractedData.filter((template: UserTemplate) => serial === template.serial).filter((template: UserTemplate) => {
                        return template.userId === parseInt(userId)
                    })
                } else if (!serial && userId) {

                    userTemplate = extractedData.filter((template: UserTemplate) => loggersDataProps.map(prop => prop.serial).includes(template.serial)).filter((template: UserTemplate) => {
                        return template.userId === parseInt(userId)
                    })
                }

                const companyTemplate: UserTemplate[] = extractedData.filter((template: UserTemplate) => {
                    return !template.serial && !template.userId
                })

                const userDefaultTemplate: UserTemplate[] = extractedData.filter((template: UserTemplate) => {
                    return !template.serial && template.userId
                })


                let loggersData = loggersDataProps ? loggersDataProps: loggers

                if (!siteId) {
                    if (userTemplate.length > 0) {
                        loggersData = loggersData.map(logger => {
                            userTemplate.forEach((template: UserTemplate) => {

                                if (template.serial === logger.serial) {
                                    logger.color = template.graphSettings.flowAColor
                                }
                            })
                           return logger 
                        })
                    } else if (userDefaultTemplate.length > 0) {
                            loggersData = loggersData.map(logger => {
                                logger.color = userDefaultTemplate[0].graphSettings.flowAColor
                                return logger
                            })
                    } else if (companyTemplate.length > 0) {
                        loggersData = loggersData.map(logger => {
                            logger.color = companyTemplate[0].graphSettings.flowAColor
                            return logger
                        })
                    } else {
                        setErrorMessage(intl.formatMessage({ id: "No Settings Found" }))
                    }

                } else {
                    if (userTemplate.length > 0) {
                        if (userTemplate.length === loggersData.length) {
                            loggersData.forEach(log => {
                                const color = userTemplate.filter(temp => temp.serial === log.serial)[0].graphSettings.flowAColor
                                log.color = color
                            })
                        } else {
                            // if some logger have custom colours but other dont we need to check down the higherarcy of settings
                            if (userDefaultTemplate.length > 0) {
                                loggersData.forEach(log => {
                                    const color = userTemplate.filter(temp => temp.serial === log.serial)[0].graphSettings.flowAColor
                                    if (color) {
                                        log.color = color
                                    } else {
                                        log.color = userDefaultTemplate[0].graphSettings.flowAColor
                                    }
                                })
                            } else if (companyTemplate.length > 0) {
                                loggersData.forEach(log => {
                                    const color = userTemplate.filter(temp => temp.serial === log.serial)[0].graphSettings.flowAColor
                                    if (color) {
                                        log.color = color
                                    } else {
                                        log.color = companyTemplate[0].graphSettings.flowAColor
                                    }
                                })
                            } 
                        }
                    } else if (userDefaultTemplate.length > 0) {
                        loggersData = loggersData.map(logger => {
                            logger.color = userDefaultTemplate[0].graphSettings.flowAColor
                            return logger
                        })
                    } else if (companyTemplate.length > 0) {
                        loggersData = loggersData.map(logger => {
                            logger.color = companyTemplate[0].graphSettings.flowAColor
                            return logger
                        })
                    } else {
                        setErrorMessage("No Settings Found")
                    }
                }
                




                //loggersUnitsAndValues.forEach(unit => unit.alarms = [])
                setLoggers(loggersData)
            })
            .catch((error) => {
                console.error(error);
                createErrorNotification()
            });

        
    }

    const handleEditAvg = () => {
        setShowModal(true)
        setTempAverageStyling(averageStyling)
    }

    const handleAvgWidthChange = (name: string, value: number):void => {
        const avgSett = { ...tempAverageStyling }
        if (name === 'width') {
            avgSett.width = value
        } else if (name === 'size') {
            avgSett.size = value
        }
       
        setTempAverageStyling(avgSett)
    }

    const handleColorChange = (e):void => {
        const avgSett = { ...tempAverageStyling }
        avgSett.color = e
        setTempAverageStyling(avgSett)
    }

    const handleShowPointsChange = (e):void => {
        const avgSett = { ...tempAverageStyling }
        avgSett.showPoints = e.target.checked
        setTempAverageStyling(avgSett)
    }

    const handleSaveAvgStyling = (): void => {
        const saveData = { ...tempAverageStyling }
        saveData.color = saveData.color.slice(1, 7)
        CallPostAPI(CreateUrl(`/api/aquaguard/userSettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF&key=Custom%20Average&value=${JSON.stringify(saveData)}`), {})
            .catch(err => {
                console.error(err)
                createErrorNotification()
            })
        setAverageStyling(tempAverageStyling)
        setShowModal(false)

    }

    const closeModal = ():void => {
        setShowModal(false)
        setTempAverageStyling(averageStyling)
    }

    return (
        <div>
            {loading &&
                <div style={{
                    position: 'absolute', left: 'Calc(50% - 100px)', top: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 13000
                }}>
                    <Loader color={undefined} />
                </div>
            }
            {!loading &&
                <div>
                    <Modal
                        show={showModal}
                        dialogClassName="modal-30w"
                        centered
                    >
                        <Modal.Header>
                            <Modal.Title><FormattedMessage id="Average Line Settings" /></Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                            <div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ margin: "0px 15px 0 0" }}><FormattedMessage id="Line Width" />:</p>
                                <CustomNumberInputChanger disabled={false} onChange={(name: string, value: number): void => handleAvgWidthChange(name, value)} name={'width'} value={tempAverageStyling.width}  />
                            </div>
                            <div style={{ display: "flex", alignItems: "center", marginTop:  "10px"}}>
                                <p style={{ margin: "0px 10px 0 0" }}><FormattedMessage id="Line Colour" />:</p>
                                <MuiColorInput format="hex" size="small" value={tempAverageStyling.color} onChange={(e):void => handleColorChange(e) } />
                            </div>
                            <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                <p style={{ margin: "0px 0px 0 0" }}><FormattedMessage id="Show Points" />:</p>
                            <Checkbox checked={tempAverageStyling.showPoints} onChange={(e): void => handleShowPointsChange(e)} />
                                {tempAverageStyling.showPoints && <div style={{ display: "flex" }} >
                                    <p style={{ margin: "8px 15px 0 15px" }}><FormattedMessage id="Size" />:</p>
                                    <CustomNumberInputChanger disabled={false} onChange={(name: string, value: number): void => handleAvgWidthChange(name, value)} name={'size'} value={tempAverageStyling.size} />
                                </div>}
                                </div>
                            </div>
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="contained" style={{ marginRight: "10px" }} onClick={():void => handleSaveAvgStyling() }><FormattedMessage id="Save" /></Button>
                            <Button variant="contained" color="error" onClick={(): void => closeModal()}><FormattedMessage id="Cancel" /></Button>
                        </Modal.Footer>
                    </Modal>
                    {!linkDates && <CardHeader color="primary" className="view view-cascade" style={{ paddingTop: "50px" }}>
                        <Grid container  >
                            <Grid item lg={12}  >
                                {/*    <div style={{display: "flex", float: "right", marginBottom: "10px"} }>*/}
                                {/*    <Button variant="contained" color="secondary" style={{ marginRight: "10px" }} onClick={resetZoom}>Reset Zoom</Button>*/}
                                {/*    <Button variant="contained" color="primary" style={{ marginRight: "10px" }}>Edit Graph Settings</Button>*/}
                                {/*</div>*/}
                                <div style={{ margin: "0px 18px 12px 25px", display: "flex" }}>
                                    <DateRange startDate={startDate} endDate={endDate} rainfall={false} onDateChange={onDateChange} type="date" showButton={dateChange} handleRedrawClick={handleRedraw} />
                                    
                                </div>
                            </Grid>
                        </Grid>
                    </CardHeader>}
                    <div style={{ marginTop: "30px", position: "relative" }}>
                        <div style={{ position: "absolute", right: "15px", display: "flex" }}>
                            <div style={{ display: "flex" }}>
                                {errorMessage && <div style={{display: "flex", justifyContent: "center", alignItems: "center", margin: "-20px 10px 0 0"} }>
                                    <div>{errorMessage}</div>
                                </div>}
                                <div style={{ display: "flex", justifyContent: "center", margin: "-20px 10px 0 0" }}>
                                    <TooltipMUI title={intl.formatMessage({ id: "Edit styling for average minimum night flow" })} >
                                        <Button variant="contained" color="secondary" onClick={(): void => handleEditAvg()}><FormattedMessage id="Edit Average Line" /></Button>
                                    </TooltipMUI>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: "-20px" }}>
                                    <TooltipMUI title={intl.formatMessage({ id: "Finds and uses your custom colours for particular device set in graph settings" })} >
                                        <Button variant="contained" color="warning" onClick={(): void => handleCustomColorClick()}>{useCustomColors ? intl.formatMessage({ id: 'Use Default Colours' }) : intl.formatMessage({ id: 'Use Custom Colours' })}</Button>
                                    </TooltipMUI>

                                </div>
                            </div>
                        </div>
                        <div style={{ position: "absolute", left: "5px", display: "flex" }}>
                            <div style={{ display: "flex" }}>
                                {showDateLink && <div style={{ margin: "-20px 0 0 10px" }}>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <TooltipMUI title={intl.formatMessage({ id: "Link the date to the graph above to view both in same range" })} >
                                            <Button variant="contained" onClick={(): void => handleLinkDatesChecked()}>{linkDates ? intl.formatMessage({ id: 'Undo Link dates' }) : intl.formatMessage({ id: 'Link Date to Graph' })}</Button>
                                        </TooltipMUI>

                                    </div>
                                </div>}
                            </div>
                        </div>
                        {graphData.length === 0 && <h4 style={{textAlign: "center"} }><FormattedMessage id="No Data Available" /></h4>}
                        {graphData &&
                            graphData?.length > 0 &&
                            loggers.length > 0 &&
                            <Chart dataSource={graphData} ref={chartRef} onLegendClick={legendClickHandler}>
                            <CommonSeriesSettings
                                argumentField="day"
                                ignoreEmptyPoints={false}
                                //type="stackedbar"
                            >
                                <Point size={15} />
                                <Font weight={900} size={40} />
                            </CommonSeriesSettings>

                            <ValueAxis
                                width={2}
                                color={loggers.length > 1 ? '#767676' : loggers[0].color}
                                title={{ text: intl.formatMessage({id: "Minimum Night Flow in l/s"}), font: { color: loggers.length > 1 ? '#767676' : loggers[0].color, size: 12 } }}
                            >
                                <Label font={{ color: loggers.length > 1 ? '#767676' : loggers[0].color }} />
                            </ValueAxis>
                            <CommonAxisSettings
                                valueMarginsEnabled={true}
                                minValueMargin={0.1}    //add extra 10% to show a 'gap'
                                maxValueMargin={0.1}     //add extra 10% to show a 'gap'
                            />
                            {loggers && loggers.length > 0 && loggers.map(logger => {
                                return renderLoggerSeries(logger)
                            })}
                            <Series
                                valueField="average"
                                color={averageStyling.color}
                                name={intl.formatMessage({ id: "7 Day Average" })}
                                type="spline"
                                width={averageStyling.width }
                                point={{ visible: averageStyling.showPoints, size: averageStyling.size }}
                            />

                            <ArgumentAxis
                                width={2}
                                allowDecimals={false}
                                argumentType="datetime"
                                minValueMargin={0.01}
                                maxValueMargin={0.01}
                                aggregationInterval="day"
                                visualRange={visualRange}

                            >
                                <GridChart visible={true} />
                            </ArgumentAxis>
                            <Legend
                                verticalAlignment="top"
                                horizontalAlignment="center"
                                markerRender={renderCheckBox}
                                customizeText={(data):string => customizeLegendText(data, intl)}

                            />

                            <Crosshair
                                enabled={true}
                                color="#949494"
                                width={3}
                                dashStyle="dot"
                            >
                                <Label
                                    visible={true}
                                    backgroundColor="#949494"
                                >
                                    <Font
                                        color="#fff"
                                        size={14}
                                    />
                                </Label>
                            </Crosshair>
                            <ZoomAndPan
                                allowMouseWheel={false}
                                argumentAxis="both"
                                valueAxis="none"
                                dragToZoom={true}
                            />
                            <Tooltip enabled={true} contentRender={(data):React.ReactNode => renderToolTip(data, intl)} />
                        </Chart>}
                        </div>
                </div>}    
        
        </div>
    )
}

export default  MinimumNightFlow